import styled from "@emotion/styled";

export const FieldContainer = styled.div({
  display: "flex",
  flexDirection: "column",
  gap: 4,
  maxWidth: 650,
});
